/**
 * @desc 列表+详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.LogisticsGroupDetailsResponseDto>>;
export function request(
  body: defs.basics.LogisticsGroupRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/logisticsGroup/list/details`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
